import { useSessionOrNull } from '~/contexts/SessionContext';
import {
    createStructureSetReadModel,
    StructureSetReadModel,
} from '~/domain/readmodels/StructureSetReadModel';
import { useDomainProjection } from '~/hooks/domain/useDomainProjection';

const EMPTY: readonly StructureSetReadModel[] = Object.freeze([]);

/**
 * Returns immutable {@link StructureSetReadModel} projections for every
 * structure set on the current patient. The export modal consumes these
 * read models instead of live `StructureSet` entities so the UI never
 * navigates domain objects directly.
 *
 * Rebuilt only when a domain mutation bumps the store version (e.g. an
 * export-panel edit committed through `useExportEditing`). Tolerates a
 * missing session: the modal can mount before a patient is loaded.
 */
export function useExportStructureSetReadModels(): readonly StructureSetReadModel[] {
    return useDomainProjection(
        useSessionOrNull(),
        'useExportStructureSetReadModels',
        [],
        (patient) => patient.structureSets.map(createStructureSetReadModel),
        EMPTY
    );
}
